import {formatISO} from "date-fns";
import LocalQueuedDbService from "../../../../services/LocalQueuedDbService";
import CoreService from "../../../../services/CoreService";


import FileManager from "../../../../managers/FileManager";

import ServiceResponse from "../../../../models/ServiceResponse";


export default class PostingManager
{

    constructor(originalValueBag, currentValueBag, userSession)
    {
        this.originalValueBag = originalValueBag ?? {};
        this.currentValueBag = currentValueBag ?? {};
        this.userSession = userSession ?? {};
        this.localQueuedDbService = new LocalQueuedDbService();
        this.coreService = new CoreService();

    }



    static allowReinspect(grade, schema)
    {
        if (!schema.scoring.postInspect?.reinspect) return false;
        var hasTriggerGrade = schema.scoring.postInspect.reinspect.grades.includes(grade.toUpperCase());
        return hasTriggerGrade;
    }


    async updateObservation(observation)
    {
        try
        {
            // let's figure out what actually changed...
            var source = this.originalValueBag;
            var target = this.currentValueBag;
            var changedValueBag = Object.fromEntries(Object.entries({ ...source, ...target }).filter(([key, value]) => !Object.is(source[key], value)));
            var changedProps = {};
            Object.keys(changedValueBag).forEach((key) => 
            {
                {
                    changedProps[key] = { "original": this.originalValueBag[key], "new": this.currentValueBag[key] };
                }
            });
      
            // we need to build an update object
            var updateEvent = 
            {
                gcid: this.userSession.gcid,
                observationId: this.currentValueBag["originalId"],
                eventDate: formatISO(new Date()),
                eventType: "update",
                eventReason: "userchange",
                eventBy: this.userSession.uid,
                eventLocation: this.userSession.currentLocationId,
                Changed: changedProps
            };
              
            // post update immediately and inform refresh
            observation.identifiers.status = 'posted';
            observation.identifiers.statusReason = 'posted update';
            var result = await this.coreService.postObservationUpdate(updateEvent, observation, this.userSession.gcid, this.userSession.token);
            // we may have NEW images and/or documents we need to save.
            var fileManager = new FileManager();
            // upload all associated images and documents
            var imgPostResult = await fileManager.uploadUserImages(observation, this.userSession);
            console.info(imgPostResult);
            var docPostResult = await fileManager.uploadUserDocuments(observation, this.userSession);
            console.info(docPostResult);
            await fileManager.deleteUserImages(observation);
            await fileManager.deleteUserDocuments(observation);

            return new ServiceResponse(false);
            
        } 
        catch(e)
        {
            var msgs = new ["Unexpected error updating observation."];
            msgs.push(e.message);
            return new ServiceResponse(true, msgs);
        }
    }

    async postPendingObservation(observation, offlineId, onUpdateInQueueCount)
    {
        try
        {
            observation.identifiers.status = 'pending';
            observation.identifiers.statusReason = 'queued for posting';
            var result = await this.localQueuedDbService.addObservation(this.userSession.gcid, observation, offlineId);
            var queueCountResult = await this.localQueuedDbService.fetchObservationCount();
            onUpdateInQueueCount(queueCountResult);
            console.group("Posting Locally");
            console.info(observation);
            console.info(result);
            console.groupEnd();
            //if (!result.hasError) onToastRequest("information", "Observation will be posted in the background...", 5000, true);
            return new ServiceResponse(false);
        } 
        catch(e)
        {
            var msgs = [];
            msgs.push("Unexpected error updating observation.");
            msgs.push(e.message);
            return new ServiceResponse(true, msgs);
        }

    }
}